import { render, staticRenderFns } from "./ValidFrom.vue?vue&type=template&id=8d571a50&"
import script from "./ValidFrom.vue?vue&type=script&lang=js&"
export * from "./ValidFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports